import { render } from "./GoogleReCaptchaV3.vue?vue&type=template&id=0be6a740"
import script from "./GoogleReCaptchaV3.vue?vue&type=script&lang=js"
export * from "./GoogleReCaptchaV3.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__